import { ClockIcon } from '@heroicons/react/24/outline'
import { useQuery, UseQueryArgs } from 'urql'
import { APP_CONTROLLISTS } from '../_constants/permissions'
import { NotAllowed } from '../_features/NotAllowed'
import { useMyself } from '../_features/UserContext'
import { UserList } from '../_features/UserList'
import { SingleColumn } from '../_layout/content'
import { readCurrentSeasonControlListQuery } from '../_lib/graphql/queries'
import { LandingHeader } from '../_ui/LandingHeader'

export const ControllistPage = () => {
  const { canAccess } = useMyself() || {}
  const [readCurrentSeasonControlListResult] = useQuery({
    query: readCurrentSeasonControlListQuery,
    pause: !canAccess || !canAccess([APP_CONTROLLISTS])
  } as UseQueryArgs)

  if (!canAccess || !canAccess([APP_CONTROLLISTS])) {
    return <NotAllowed />
  }

  return (
    <SingleColumn>
      <LandingHeader
        title={'Kontrolllisten'}
        icon={props => <ClockIcon {...props} />}
      />

      <div className={'w-full max-w-[1400px] mx-auto p-8'}>
        <h3 className={'text-xl font-medium tracking-tight text-gray-900 sm:text-2xl mb-4'}>Benutzer mit Verfügbarkeiten,
          die nicht in der Festivalgruppe sind</h3>
        <UserList
          user={readCurrentSeasonControlListResult.data?.readCurrentSeason?.userWithAvailabilitiesWithoutTargetGroup || []}
          fetching={readCurrentSeasonControlListResult.fetching}
        />
      </div>

      {/*<div className={'w-full max-w-[1400px] mx-auto p-8'}>*/}
      {/*  <h3 className={'text-xl font-medium tracking-tight text-gray-900 sm:text-2xl mb-4'}>*/}
      {/*    Benutzer in der Festivalgruppe, die keine Bereichszuordnung haben*/}
      {/*  </h3>*/}
      {/*  <p className={'text-sm text-gray-500 mb-4'}>*/}
      {/*    Diese Benutzer:innen haben sich in der Festivalhelfenden Gruppe eingetragen, aber keine Bereichszuordnung.*/}
      {/*    Sie können daher keine Schichten angeben und den Punkt "Mein Festival" nicht sehen.*/}
      {/*    <strong className={'block mt-2'}>Bitte füge diese Personen einem Bereich hinzu.</strong>*/}
      {/*  </p>*/}
      {/*  <UserList*/}
      {/*    user={readCurrentSeasonControlListResult.data?.readCurrentSeason?.userInTargetGroupWithoutSection || []}*/}
      {/*    fetching={readCurrentSeasonControlListResult.fetching}*/}
      {/*  />*/}
      {/*</div>*/}

      <div className={'w-full max-w-[1400px] mx-auto p-8'}>
        <h3 className={'text-xl font-medium tracking-tight text-gray-900 sm:text-2xl mb-4'}>
          Benutzer mit Bereichszuordnung, die nicht in der Festivalgruppe sind
        </h3>
        <p className={'text-sm text-gray-500 mb-4'}>
          Diese Benutzer:innen haben eine Bereichszuordnung und können im Menüpunkt "Mein Festival" Verfügbarkeiten
          für Schichten angeben. Sie sind nicht in der Festivalhelfenden Gruppe, und können daher für die T-Shirt-Bestellung
          oder Essensplanung nicht berücksichtigt werden. Entsprechend sollte diese Liste im optimalen Fall leer sein.
          <strong className={'block mt-2'}>Bitte füge diese Personen zur Gruppe hinzu und bitte sie, die nötigen Informationen auszufüllen.</strong>
        </p>
        <UserList
          user={readCurrentSeasonControlListResult.data?.readCurrentSeason?.userWithSectionsWithoutTargetGroup || []}
          fetching={readCurrentSeasonControlListResult.fetching}
        />
      </div>

      <div className={'w-full max-w-[1400px] mx-auto p-8'}>
        <h3 className={'text-xl font-medium tracking-tight text-gray-900 sm:text-2xl mb-4'}>
          Benutzer mit bestätigten Schichten, die nicht in der Festivalgruppe sind
        </h3>
        <p className={'text-sm text-gray-500 mb-4'}>
          Diese Benutzer:innen haben Bereits Schichten zugeordnet bekommen, sind aber nicht in der Festivalhelfenden Gruppe
          und können daher für die T-Shirt-Bestellung oder Essensplanung nicht berücksichtigt werden.
          Entsprechend sollte diese Liste im optimalen Fall leer sein.
          <strong className={'block mt-2'}>Bitte füge diese Personen zur Gruppe hinzu und bitte sie, die nötigen Informationen auszufüllen.</strong>
        </p>
        <UserList
          user={readCurrentSeasonControlListResult.data?.readCurrentSeason?.userWithSlotsWithoutTargetGroup || []}
          fetching={readCurrentSeasonControlListResult.fetching}
        />
      </div>

      <div className={'mb-8'}> </div>
      {/*<Routes>*/}
      {/*  <Route path={':passID'} element={<PassesList />} />*/}
      {/*  <Route index element={<PassesList />} />*/}
      {/*</Routes>*/}
    </SingleColumn>
  )
}
